import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
const isVideo = data => data.mimeType.indexOf('video/') !== -1;
export function toItem(data) {
  return {
    id: data.id,
    name: data.filename,
    kind: ItemKind.File,
    source: 'googlePhotos',
    mediaType: isVideo(data) ? MediaType.Video : MediaType.Picture,
    fileUrl: isVideo(data) ? `${data.baseUrl}=dv` : `${data.baseUrl}=d`,
    thumbnailUrl: `${data.baseUrl}=w150-h150`,
    previewUrl: `${data.baseUrl}=w300-h300`,
    createdAt: data.mediaMetadata && data.mediaMetadata.creationTime,
    tags: [],
    width: data.mediaMetadata && parseInt(data.mediaMetadata.width, 10) || 1024,
    height: data.mediaMetadata && parseInt(data.mediaMetadata.height, 10) || 768
  };
}